import React from "react";
import gsoc from './assets/gsoc.png';
import ieee from './assets/ieee.jpeg';
import "./certification.css"

export default function Certifications() {
    return (
        <section className="blog-posts">
          <div className="blog-posts-list">
              <div className="blog-post-item">
                <a href="https://trf-placement-website.netlify.app/" className="custom-link">
                  <div className="blog-banner-box">
                    <img src={gsoc} alt="Logo" />
                  </div>
                  <div className="blog-content">
                              <div className="blog-meta">
                                 <p className="blog-category">Google Summer of Code</p>
                                 <span className="dot"></span>
                                 <time datetime="2022-02-23">July 2023 - October 2023</time>
                              </div>
                           </div>
                </a>
              </div>
              <div className="blog-post-item">
                <a href="https://ieeexplore.ieee.org/document/9741028" className="custom-link">
                  <div className="blog-banner-box">
                    <img src={ieee} alt="Logo" />
                  </div>
                  <div className="blog-content">
                              <div className="blog-meta">
                                 <p className="blog-category">IEEE Research Paper</p>
                                 <span className="dot"></span>
                                 <time datetime="2022-02-23">July 2023 - October 2023</time>
                              </div>
                           </div>
                </a>
              </div>
            </div>
        </section>
    );
}
